import { render, staticRenderFns } from "./bindRoles.vue?vue&type=template&id=72faaaec&scoped=true"
import script from "./bindRoles.vue?vue&type=script&lang=js"
export * from "./bindRoles.vue?vue&type=script&lang=js"
import style0 from "./bindRoles.vue?vue&type=style&index=0&id=72faaaec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72faaaec",
  null
  
)

export default component.exports